<div class="container mt-5 ps-5 min-vh-79 mb-5">
  <div class="card-header py-3">
    <h1 class="mb-0">Subscriptions</h1>
  </div>

  <div class="card h-100 min-vh-79">
    <div class="card-body flex-none row">

      <div class="row">
        <div class="col-12 d-flex justify-content-end pb-5">
          <button class="btn btn-outline-primary rounded-5 d-flex align-items-center justify-content-center gap-2"
                  [routerLink]="'/subscriptions/manage'"
          >
            <mat-icon class="d-flex align-items-center justify-content-center">add</mat-icon>
            Create New Subscription
          </button>
        </div>
      </div>

      <div class="row" *ngIf="loading">
        <div class="col-12 d-flex justify-content-center">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      </div>

      <div class="row" *ngIf="!loading && subscriptions.length === 0">
        <div class="col-12 text-center">
          <p class="fs-4 text-gray">No subscriptions found. Create a new subscription to get started.</p>
        </div>
      </div>

      <div class="row" *ngIf="!loading && subscriptions.length > 0">
        <div class="col-12 d-flex flex-wrap">
          <div class="p-2 col-12 col-md-6 col-lg-4"
               *ngFor="let subscription of subscriptions">
            <div class="card-bordered border-1 rounded-2 p-3 h-100 d-flex flex-column">
              <!-- Card Header Section -->
              <div class="flex-grow-0">
                <div class="d-flex flex-column gap-1">
                  <div class="d-flex flex-column gap-2">
                    <div class="d-flex justify-content-between align-items-center">
                      <span class="primary-text-color fs-3 fw-bolder">{{ subscription.subscriptionName }}</span>
                      <span class="badge rounded-pill"
                            [ngClass]="{
                            'bg-warning': subscription.status === SubscriptionStatus.DRAFT,
                            'bg-success': subscription.status === SubscriptionStatus.PUBLISHED,
                            'bg-gray-400': subscription.status === SubscriptionStatus.ARCHIVED,
                            'bg-danger': subscription.status === SubscriptionStatus.DEACTIVATED
                            }"
                      >
                        {{ subscription.status | titlecase }}
                      </span>
                    </div>
                    <span class="text-gray fs-5">{{ subscription.description }}</span>
                  </div>
                  <br>
                  <div class="d-flex flex-row gap-1">
                    <span class="primary-text-color fs-2 fw-bolder">{{ formatPrice(subscription.monthlyPrice) }}</span>
                    <span class="primary-text-color fs-3 fw-bold mt-1">/ per month</span>
                  </div>
                  <div class="d-flex flex-column mt-2">
                    <span class="text-gray fs-5">Annual Monthly Rate:
                      <span
                        [ngClass]="{'text-success': subscription.discountedAnnualRate, 'text-primary': !subscription.discountedAnnualRate}">
                        {{ subscription.discountedAnnualRate ? formatPrice(subscription.discountedAnnualRate) : formatPrice(subscription.monthlyPrice) }}
                      </span>
                    </span>
                    <span class="text-gray fs-5">Total Annual Price:
                      <span class="fw-bold"
                            [ngClass]="{'text-success': subscription.discountedAnnualRate, 'text-primary': !subscription.discountedAnnualRate}">
                        {{ calculateTotalAnnualPrice(subscription) }}
                      </span>
                    </span>
                  </div>
                </div>

                <hr class="w-100 my-4">
              </div>

              <!-- Card Body/Features Section -->
              <div class="flex-grow-1">
                <div class="d-flex flex-column gap-2 mb-4">
                  <!-- Basic Features -->
                  <div class="d-flex flex-row gap-3 align-items-center">
                    <mat-icon [class]="subscription.features.aiIntegration ? 'text-primary' : 'text-gray'">
                      {{ subscription.features.aiIntegration ? 'check' : 'close' }}
                    </mat-icon>
                    <span class="fs-5 text-gray">AI Integration</span>
                  </div>
                  <div class="d-flex flex-row gap-3 align-items-center">
                    <mat-icon class="text-primary">check</mat-icon>
                    <span class="fs-5 text-gray">Up to {{ subscription.features.maxQuizRespondents }}
                      respondents/month</span>
                  </div>
                  <div class="d-flex flex-row gap-3 align-items-center">
                    <mat-icon class="text-primary">check</mat-icon>
                    <span class="fs-5 text-gray">Up to {{ subscription.features.maxQuestionsPerQuiz }} questions per quiz</span>
                  </div>

                  <!-- Advanced Features -->
                  <div class="d-flex flex-row gap-3 align-items-center"
                       *ngIf="subscription.features.questionsOrder.randomOrder">
                    <mat-icon class="text-primary">check</mat-icon>
                    <span class="fs-5 text-gray">Random questions and answers order</span>
                  </div>
                  <div class="d-flex flex-row gap-3 align-items-center"
                       *ngIf="subscription.features.questionsOrder.allowSkipping">
                    <mat-icon class="text-primary">check</mat-icon>
                    <span class="fs-5 text-gray">Answer questions in any order</span>
                  </div>
                  <div class="d-flex flex-row gap-3 align-items-center"
                       *ngIf="subscription.features.testDuration.enabled">
                    <mat-icon class="text-primary">check</mat-icon>
                    <span class="fs-5 text-gray">Time limit: {{ subscription.features.testDuration.durationInMinutes }}
                      minutes</span>
                  </div>
                  <div class="d-flex flex-row gap-3 align-items-center"
                       *ngIf="subscription.features.honestRespondentTech.enabled">
                    <mat-icon class="text-primary">check</mat-icon>
                    <span class="fs-5 text-gray">
                      Honest Respondent Technology
                      {{ subscription.features.honestRespondentTech.blockOnDetection ? '(with blocking)' : '(warnings only)' }}
                    </span>
                  </div>
                  <div class="d-flex flex-row gap-3 align-items-center" *ngIf="subscription.features.aiAnswerReview">
                    <mat-icon class="text-primary">check</mat-icon>
                    <span class="fs-5 text-gray">AI Answer Review</span>
                  </div>
                </div>
              </div>

              <!-- Card Footer/Buttons Section -->
              <div class="flex-grow-0 mt-auto">
                <div class="d-flex flex-column gap-2">
                  <div class="col-md-12">
                    <button
                      class="btn btn-outline-primary w-100 rounded-5 gap-2 d-flex align-items-center justify-content-center mb-2"
                      (click)="editSubscription(subscription.id!)"
                    >
                      <mat-icon class="d-flex align-items-center justify-content-center">edit</mat-icon>
                      Edit
                    </button>
                  </div>
                  <div class="col-md-12">
                    <div class="dropdown w-100">
                      <button
                        class="btn btn-outline-secondary w-100 rounded-5 gap-2 d-flex align-items-center justify-content-center mb-2 dropdown-toggle"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <mat-icon class="d-flex align-items-center justify-content-center">settings</mat-icon>
                        Change Status
                      </button>
                      <ul class="dropdown-menu w-100">
                        <li>
                          <button class="dropdown-item d-flex align-items-center gap-2 py-2"
                                  (click)="updateSubscriptionStatus(subscription.id!, SubscriptionStatus.DRAFT)"
                                  [disabled]="subscription.status === SubscriptionStatus.DRAFT">
                            <span class="badge rounded-pill bg-warning me-2">Draft</span>
                            Set as Draft
                          </button>
                        </li>
                        <li>
                          <button class="dropdown-item d-flex align-items-center gap-2 py-2"
                                  (click)="updateSubscriptionStatus(subscription.id!, SubscriptionStatus.PUBLISHED)"
                                  [disabled]="subscription.status === SubscriptionStatus.PUBLISHED">
                            <span class="badge rounded-pill bg-success me-2">Published</span>
                            Set as Published
                          </button>
                        </li>
                        <li>
                          <button class="dropdown-item d-flex align-items-center gap-2 py-2"
                                  (click)="updateSubscriptionStatus(subscription.id!, SubscriptionStatus.ARCHIVED)"
                                  [disabled]="subscription.status === SubscriptionStatus.ARCHIVED">
                            <span class="badge rounded-pill bg-gray-400 me-2">Archived</span>
                            Set as Archived
                          </button>
                        </li>
                        <li>
                          <button class="dropdown-item d-flex align-items-center gap-2 py-2"
                                  (click)="updateSubscriptionStatus(subscription.id!, SubscriptionStatus.DEACTIVATED)"
                                  [disabled]="subscription.status === SubscriptionStatus.DEACTIVATED">
                            <span class="badge rounded-pill bg-danger me-2">Deactivated</span>
                            Set as Deactivated
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <button
                      class="btn btn-outline-secondary w-100 rounded-5 gap-2 d-flex align-items-center justify-content-center"
                      (click)="viewSubscriptionDetails(subscription)"
                    >
                      <mat-icon class="d-flex align-items-center justify-content-center">visibility</mat-icon>
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
